module.exports = __webpack_public_path__ + "img/jpm_icons1.0ae0582d.svg";